import { render, staticRenderFns } from "./newsAnnouncement.vue?vue&type=template&id=4245f56a&scoped=true"
import script from "./newsAnnouncement.vue?vue&type=script&lang=js"
export * from "./newsAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./newsAnnouncement.vue?vue&type=style&index=0&id=4245f56a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4245f56a",
  null
  
)

export default component.exports